// extracted by mini-css-extract-plugin
module.exports = {"input":"IndustriesFormItem_input__2HEIe"};